import {
  Paper,
  Box,
  Typography,
  Button,
  Avatar,
  Chip as MUIChip,
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import union_left from '../icons/union_left.svg';
import union_right from '../icons/union_right.svg';
import add_boards from '../icons/add_boards.svg';
import dateFormat from '../utils/dateFormat';

const BoardCard = (props) => {
  const {
    board,
    hideMemberSince,
    hideHeadline,
    bigCompanyName,
    companyList,
    onClick,
    width,
    height,
    Chip = null,
    displayPillsFlag,
  } = props;
  const parentfileId = 'a5278712-a5e3-4bbb-89e1-4cfcc678e87f';
  const wonderDadsId = 'cf9c6fab-92b5-41a8-ba3c-0505fd778fd5';
  // const parentfileId = '9eccc760-d90f-45fb-96a3-b3b717c6f1b0'; // incative
  // const wonderDadsId = 'c526bb11-a138-42fa-b5ac-37abaa6cf0d2'; // cleaning

  const ParentfileChip = () => (
    <MUIChip
      label="1% Equity Pledge"
      size="small"
      sx={{
        position: 'absolute',
        fontSize: '12px',
        height: '20px',
        top: -10,
        right: { xxs: -12, xs: -10 },
        zIndex: 10,
        backgroundColor: '#f3f4f6',
        fontWeight: 500,
        padding: '13px 25px',
      }}
    />
  );
  const WonderDadsChip = () => (
    <MUIChip
      label="Limited Space Available"
      size="small"
      sx={{
        position: 'absolute',
        fontSize: '12px',
        height: '20px',
        top: -10,
        right: { xxs: -12, xs: -10 },
        zIndex: 10,
        backgroundColor: '#FDE2E0',
        fontWeight: 500,
        padding: '13px 25px',
      }}
    />
  );

  const history = useHistory();
  const dateObj = board.createdAt ? new Date(board.createdAt) : new Date();
  const year = dateFormat(dateObj, 'yyyy');
  const haveImage =
    (board.companyLogo && !board.companyLogo.includes('undefined')) ||
    board.image?.location;

  const categoryMap = {
    'Compensation Potential': { icon: '💰', label: 'Compensation Potential' },
    'Equity Potential': { icon: '📈', label: 'Equity Potential' },
    'Formal Roles': { icon: '💼', label: 'Formal Roles' },
    Perks: { icon: '🎁', label: 'Perks' },
  };

  const allPills = [];
  const featuredBenefits = board.benefits
    ? board.benefits.filter((benefit) => benefit.featured)
    : [];
  Object.entries(categoryMap).forEach(([cat, { icon, label }]) => {
    if (featuredBenefits?.some((b) => b.category === cat)) {
      allPills.push({ icon, label });
    }
  });
  if ((featuredBenefits?.length ?? 0) < 4) {
    allPills.push({ icon: '📝', label: 'Add to Resume' });
  }

  const MAX_CELLS = 4;
  let displayPills = allPills;
  if (allPills.length > MAX_CELLS) {
    const overflowCount = allPills.length - (MAX_CELLS - 1);
    displayPills = [
      ...allPills.slice(0, MAX_CELLS - 1),
      { icon: '+', label: `${overflowCount} more` },
    ];
  }

  function getHeight() {
    if (height) {
      return height;
    }
    if (!board.createdAt) {
      return 'auto';
    }
    if (displayPillsFlag) {
      return '318px';
    }
    return '265px';
  }

  return (
    <Paper
      className={
        board.createdAt
          ? `my-board-${board.boardType === 'P2P' ? 'p2p' : 'card'}`
          : 'view-boardrooms'
      }
      elevation={1}
      sx={{
        height: getHeight(),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: companyList ? '0px 16px 16px' : '16px',
        borderRadius: '12px',
        textAlign: 'center',
        boxShadow: '0px 10px 12px 0px #0010300D',
        width: width || '100%',
      }}
    >
      <div
        style={{
          width: 'calc(100% + 32px)',
          left: '-16px',
          height: '56px',
          background: 'linear-gradient(#2C71F633, #25A4FF33)',
          borderRadius: '8px 8px 0px 0px',
          position: 'relative',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
        }}
      >
        {Chip && ![parentfileId, wonderDadsId].includes(board?.id) && <Chip />}

        {Chip && board?.id === parentfileId && <ParentfileChip />}
        {Chip && board?.id === wonderDadsId && <WonderDadsChip />}

        <img
          src={union_left}
          alt="left"
          style={{ position: 'absolute', zIndex: 1, left: 0, marginTop: 25 }}
        />
        <img
          src={union_right}
          alt="right"
          style={{ position: 'absolute', zIndex: 1, right: 0 }}
        />
        <Box
          sx={{
            zIndex: 2,
            position: 'absolute',
            marginTop: '26px',
            height: 72,
            width: 72,
            backgroundColor: 'white',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Avatar
            src={
              haveImage
                ? `https://${board.companyLogo || board.image?.location}`
                : add_boards
            }
            sx={{
              height: haveImage ? '100%' : 60,
              width: haveImage ? '100%' : 60,
              borderRadius: '8px',
            }}
          />
        </Box>
      </div>
      <Box sx={{ marginTop: '38px' }}>
        <Typography
          sx={{
            fontSize: bigCompanyName ? '24px' : '16px',
            fontWeight: '600',
            marginBottom: !board.createdAt ? '10px' : '0',
            textOverflow: bigCompanyName ? null : 'ellipsis',
            overflow: bigCompanyName ? null : 'hidden',
            whiteSpace: bigCompanyName ? null : 'nowrap',
          }}
        >
          {board.companyName}
        </Typography>

        {!hideMemberSince && board.createdAt ? (
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: '400',
              color: '#4D586F',
              marginBottom: '5px',
            }}
          >
            Board Member Since: {year}
          </Typography>
        ) : null}

        {board.headline && !hideHeadline ? (
          <Typography
            sx={{
              fontSize: '12px',
              color: '#4D586F',
              fontWeight: '400',
              lineHeight: '18px',
              marginBottom: '6px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              whiteSpace: 'normal',
            }}
          >
            {board.headline}
          </Typography>
        ) : null}
      </Box>
      {displayPillsFlag && displayPills.length > 0 ? (
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: 1,
            maxWidth: 'calc(100% + 20px)',
            boxSizing: 'border-box',
            mb: 1,
            mx: '-10px',
            overflow: 'hidden',
            maxHeight: '60px',
          }}
        >
          {displayPills.map((pill) => (
            <MUIChip
              key={pill.label}
              size="small"
              icon={<span style={{ fontSize: '12px' }}>{pill.icon}</span>}
              label={pill.label}
              sx={{
                fontSize: '12px',
                fontWeight: '500',
                px: 0.8,
                py: 0.4,
                borderRadius: '1em',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                backgroundColor: '#f3f4f6',
              }}
              aria-label={pill.label}
            />
          ))}
        </Box>
      ) : null}

      <Button
        variant="outlined"
        className={`${companyList ? 'view-company-button' : ''}`}
        onClick={() => {
          if (companyList && onClick) {
            onClick();
          } else if (board.createdAt) {
            history.push(`/${board.slug}/boardroom`);
          } else {
            history.push(`/board-directory`);
          }
        }}
        sx={{
          textTransform: 'none',
          fontSize: '14px',
          padding: '6px 12px',
          borderRadius: 2,
          borderColor: 'hsla(219, 92%, 57%, 1)',
          color: 'hsla(219, 92%, 57%, 1)',
          borderWidth: '1px',
          backgroundColor: 'white',
        }}
      >
        {board.createdAt ? 'View' : 'View Boards'}
      </Button>
    </Paper>
  );
};

export default BoardCard;
